import { Box, ListSubheader, Typography, useTheme } from '@mui/material'

interface Props {
  text: string
  size?: 'small' | 'large'
  leftComponent?: React.ReactNode
  rightComponent?: React.ReactNode
}

function CardSectionTitle(props: Props) {
  const { text, size = 'small', leftComponent, rightComponent } = props
  const theme = useTheme()
  const isLarge = size === 'large'

  return (
    <ListSubheader sx={{ height: theme.spacing(9), alignItems: 'center', display: 'flex', justifyContent: 'space-between' }}>
      <Box>
        {leftComponent}
        <Typography
          variant={isLarge ? 'body0' : 'overline'}
          sx={{ lineHeight: 1, color: isLarge ? 'text.primary' : 'text.secondary', fontWeight: 'medium' }}
        >
          {text}
        </Typography>
      </Box>

      {rightComponent}
    </ListSubheader>
  )
}

export default CardSectionTitle
